// extracted by mini-css-extract-plugin
export default {"footerContainer":"datagridFooter_footerContainer__nFBS+","footerText":"datagridFooter_footerText__XEqAA"};